import React, {useState} from 'react';
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/styles";
import IndexHeader from '../Index/IndexHeader';
import {sendEmailDB} from '../../../firebase';
import CustomerPreviewTemplate from './CustomerPreviewTemplate';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ConfirmDialog from '../ConfirmDialog';
import {Toaster, toast} from "sonner";

function CustomerTemplate(props) {
    const cn = useStyles();

    const [formData, setFormData] = useState({
        to:'',
        subject:'',
        customerName: props.templateData.data.name,
        companyName:props.templateData.data.company_name,
        paymentLink: props.templateData.data.payment_link,
        action: props.templateData.data.action,
        extraText:props.templateData.data.extra_text,
      });

     const [errors, setErrors] = useState({});
     const [confirm, setConfirm] = useState(false);
     const [emails, setEmails] = useState([]);
     const [inputValue, setInputValue] = useState("");
     const [loading, setLoading] = useState(false);
 
   const handleInputChange2 = (e) => {
     setInputValue(e.target.value);
   };
 
   const handleKeyDown = (e) => {
     if (e.key === " " || e.key === "Enter") {
       e.preventDefault();
       const email = inputValue.trim();
         if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) 
             if (!emails.some((item) => item.email === email)) {
             setEmails((prevEmails) => [
                 ...prevEmails,
                 {email, name: ""},
             ]);
             setInputValue(""); 
             } else {
                toast.error('This email has already been added' , {
                    position: 'bottom-left',
                    closeButton: true,
                    icon: <ErrorIcon htmlColor="#e74c3c" />,
                  });
             }
          else if (email) 
                toast.error('Ivalid email format' , {
                    position: 'bottom-left',
                    closeButton: true,
                    icon: <ErrorIcon htmlColor="#e74c3c" />,
                });
         
         }
     };
 
     const removeEmail = (indexToRemove) => {
             setEmails((prevEmails) => prevEmails.filter((_, index) => index !== indexToRemove));
     };

      const handleInputChange = (event) => {
        const {name, value} = event.target;
    
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };

      const validateForm = () => {
        const newErrors = {};
        if (!formData.to.trim()) 
          newErrors.to = 'the field is required';
        
        if (!formData.subject.trim()) 
            newErrors.subject = 'the field is required';
          
      
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };

  const handleSendEmail= () => {
    if (validateForm()) {
       
        setLoading(true);
        const sendEmail = async () => {
            const payload ={
                to: [{
                    email:formData.to,
                    name:'',
                }],
                cc: emails,
                subject: formData.subject,
                name: formData.customerName,
                companyName: formData.companyName,
                paymentLink: formData.paymentLink,
                action:formData.action,
                extraText: formData.extraText,
            }
            try {
             await sendEmailDB(props.templateData.templateId,payload);
             setLoading(false);
             setConfirm(false);
             toast.info(`Email sent successfully!`, {
                position: 'bottom-left',
                closeButton: true,
                icon: <CheckCircleIcon htmlColor="#2ecc71"/>,
              });
              setErrors({});
              props.setIsTemplateOpen(false)
            } catch (e) {
                setLoading(false);
                setConfirm(false);
                toast.error('Oops! An error occurred' , {
                    position: 'bottom-left',
                    closeButton: true,
                    icon: <ErrorIcon htmlColor="#e74c3c" />,
                  });
            }
          }
          sendEmail();
      } else {
        setConfirm(false)
      }
  };
   

    return (
        <div className={cn.templatesIndex}>
            <IndexHeader title={props.templateData.name} />
            <Button
                classes={{root: cn.backButton}}
                variant="contained"
                onClick={()=>props.setIsTemplateOpen(false)}
                >
                <span className={cn.buttonLabel}>Back</span>
            </Button>
            <div className={cn.templateDetail}>
                <div className={cn.halfdiv1}>
                    <div className={cn.formContainer}>
                        <div className={cn.templateTitle}>{"Send email"}</div>
                        <div className={cn.editForm}>
                            <div className={cn.InputField}>
                                <label >To:</label>
                                <input className={cn.inInput} name="to" value={formData.to} onChange={handleInputChange}></input>
                            </div>
                            {errors.to && <span className={cn.textAlert}>{errors.to}</span>}
                            <div className={cn.tagsContainer}>
                                <div>Cc:</div>
                                {emails.map((emailObj, index) => (
                                <div key={index} className={cn.tag}>
                                    {emailObj.email}
                                    <button
                                        type="button"
                                        onClick={() => removeEmail(index)}
                                        className={cn.removeButton}
                                    >
                                    ×
                                    </button>
                                </div>
                                ))}
                                <input
                                    type="text"
                                    value={inputValue}
                                    onChange={handleInputChange2}
                                    onKeyDown={handleKeyDown}
                                    placeholder="Type emails and press Space or Enter"
                                    className={cn.input}
                                />
                            </div>
                            <div className={cn.InputField}>
                                <label >Subject:</label>
                                <input className={cn.inInput} name="subject" value={formData.subject} onChange={handleInputChange}></input>
                            </div>
                            {errors.subject && <span className={cn.textAlert} >{errors.subject}</span>}
                            <div className={cn.InputField}>
                                <label >Customer Name:</label>
                                <input className={cn.inInput} onChange={handleInputChange} name='customerName' value={formData.customerName}></input>
                            </div>
                            <div className={cn.InputField}>
                                <label >Company Name:</label>
                                <input className={cn.inInput} onChange={handleInputChange} name='companyName' value={formData.companyName}></input>
                            </div>
                            <div className={cn.textAreaFieldFooter}>
                                <label >Payment Link:</label>
                                <textarea className={cn.inTextAreaFooter}  onChange={handleInputChange} name='paymentLink' value={formData.paymentLink}></textarea>
                            </div>
                            <div className={cn.InputField}>
                                <label>Action:</label>
                                <select 
                                    className={cn.inInput} 
                                    onChange={handleInputChange} 
                                    name="action" 
                                    value={formData.action}
                                >
                                    <option value="" disabled>Select an action</option>
                                    <option value="move">Move</option>
                                    <option value="storage">Storage</option>
                                </select>
                            </div>
                            <div className={cn.textAreaFieldFooter}>
                                <label >Extra text:</label>
                                <textarea className={cn.inTextAreaFooter}  onChange={handleInputChange} name='extraText' value={formData.extraText}></textarea>
                            </div>
                        </div>
                        <div className={cn.sendBTN}>
                            <Button
                                onClick={()=>setConfirm(true)}
                                className={cn.btnClass}
                                spaced>
                                Send Email
                            </Button>
                        </div>
                    </div>
                </div>
                <div className={cn.halfdiv}>
                <CustomerPreviewTemplate customerName={formData.customerName} companyName={formData.companyName} action={formData.action} extraText={formData.extraText} paymentLink={formData.paymentLink}
                />
                </div>
            </div>
            <div>
            </div>
            <ConfirmDialog
                open={confirm}
                handleClose={() => setConfirm(false)}
                handleConfirm={handleSendEmail}
                title={'Confirmation'}
                message={`Are you sure you want to send the email?`}
                disabled={loading}
            />
            <Toaster position="bottom-right"  />
        </div>

    );
};

const useStyles = makeStyles({
    textAlert:{
        fontSize:'10px',
        color: 'red',
        fontWeight:"bold",
    },
    padd:{
        paddingBottom:'0',
    },
    sendBTN: {
        display: 'flex',
        justifyContent: 'end',
        marginTop: '15px',
    },
    textAreaFieldFooter: {
        outlineStyle: 'none',
        display: 'block',
        background: '#f3f3f3',
        padding: '7px',
        paddingLeft: '10px',
        minHeight: '100px',
        fontSize: '14px',
        borderRadius: "4px",
        color: '#757575',
        marginBottom: '4px',
        marginTop: '4px',
        alignItems: 'center',
    },
    label: {
        color: '#757575',
        marginBottom: '10px',
    },
    templatesIndex: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '25px',
    },
  
    templateDetail: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        background: '#f3f3f3',
        padding: '2px 50px 25px 10px',
        marginTop: '15px',

    }, 

    formContainer: {
        background: "white",
        padding: '15px',
        boxShadow: '4px 4px 10px rgba(0, 0, 0, 0.1)',
    },

    halfdiv1: {
        flex: 1,
        padding: '18px',
    },
    halfdiv: {
        flex: 1,
        padding: '18px',
    },
    backButton: {
        background: 'white',
        width: '100px',
        marginTop: '10px',
    },
    templateTitle: {
        marginTop: '25px',
        fontSize: '23px',
        marginBottom: '25px',
        paddingLeft: '25px',
    },
  
    editForm: {
        display: "flex",
        flexDirection: "column",
        paddingRight: '20px',
        paddingLeft: '20px',
    },
   
    field: {
        fontSize: "12px",
    },
    InputField: {
        outlineStyle: 'none',
        display: 'flex',
        background: '#f3f3f3',
        padding: '7px',
        paddingLeft: '10px',
        height: '45px',
        fontSize: '14px',
        borderRadius: "4px",
        color: '#757575',
        marginBottom: '4px',
        marginTop: '4px',
        alignItems: 'center',
        width: '100%',
    },

    inInput: {
        flex: 1,
        border: 'none',
        background: '#f3f3f3',
        color: "#2B2B2B",
        fontSize: '14px',
        marginLeft: '8px',
        '&:focus': {
            border: 'none', 
            outline: 'none', 

        },

    },

   btnClass:{
    background: '#147DC1',
    color: '#fff',
    fontSize: '13px',
    fontWeight: '600',
    '&:hover': {
        background: '#1D92D0', 

    },
},
    inTextArea: {
        border: 'none',
        background: '#f3f3f3',
        color: "#2B2B2B",
        minHeight: '120px',
        fontSize: '14px',
        marginLeft: '8px',
        width: '95%',
        '&:focus': {
            border: 'none',
            outline: 'none',

        },
    },
    inTextAreaFooter: {
        border: 'none',
        background: '#f3f3f3',
        color: "#2B2B2B",
        minHeight: '80px',
        fontSize: '14px',
        marginLeft: '8px',
        width: '95%',
        '&:focus': {
            border: 'none',
            outline: 'none',

        },
    },
    tagsContainer: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        borderRadius: "4px",
        padding: "5px",
        minHeight: "45px",
        outlineStyle: 'none',
        background: '#f3f3f3',
        fontSize:'14px',
      },
      tag: {
        display: "flex",
        alignItems: "center",
        background: "#e0e0e0",
        borderRadius: "4px",
        padding: "5px 10px",
        margin: "5px",
        fontSize: "14px",
      },
      removeButton: {
        marginLeft: "10px",
        background: "transparent",
        border: "none",
        color: "#333",
        fontWeight: "bold",
        cursor: "pointer",
      },
      input: {
        flex: "1",
        border: "none",
        outline: "none",
        fontSize: "14px",
        padding: "5px",
      },
});

export default CustomerTemplate;
